import { useSelector } from 'react-redux';
import I18n from '../../config/i18n';
import { Row, Col } from '../../utils/grid/Grid';
import RatingWithBar from '../../features/accommodationReviews/components/RatingWithBar';
import ReviewDisplay from '../../features/accommodationReviews/components/ReviewDisplay';
import LoadMoreReviewsButton from '../../features/accommodationReviews/components/LoadMoreReviewsButton';

import './DetailsReviews.css';
import { RootState } from '../../config/redux/types';
import { Review } from '../../features/accommodationReviews/types';

export default function DetailsReviewsComponent(): JSX.Element | null {
  const accommodationReviews = useSelector((state: RootState) => state.accommodationReviews);

  if (
    accommodationReviews == null ||
    accommodationReviews.avgRatings == null ||
    accommodationReviews.reviews == null ||
    accommodationReviews.pagination == null
  ) {
    return null;
  }

  return (
    <div>
      <Row className="detail-reviews__row">
        <Col className="detail-reviews__rating-cell" xs={12} md={6}>
          <RatingWithBar
            label={I18n.t('accommodation_reviews.comfort')}
            rating={accommodationReviews.avgRatings.avgRatingComfort}
          />
        </Col>
        <Col className="detail-reviews__rating-cell" xs={12} md={6}>
          <RatingWithBar
            label={I18n.t('accommodation_reviews.cleanliness')}
            rating={accommodationReviews.avgRatings.avgRatingCleanliness}
          />
        </Col>
        <Col className="detail-reviews__rating-cell" xs={12} md={6}>
          <RatingWithBar
            label={I18n.t('accommodation_reviews.value')}
            rating={accommodationReviews.avgRatings.avgRatingValue}
          />
        </Col>
        <Col className="detail-reviews__rating-cell" xs={12} md={6}>
          <RatingWithBar
            label={I18n.t('accommodation_reviews.area')}
            rating={accommodationReviews.avgRatings.avgRatingArea}
          />
        </Col>
      </Row>
      <Row>
        {accommodationReviews &&
          accommodationReviews.reviews.map((review: Review) => (
            <Col key={review.id} xs={12} md={6}>
              <ReviewDisplay review={review} />
            </Col>
          ))}
      </Row>
      {accommodationReviews.pagination.currentPage < accommodationReviews.pagination.totalPages ? (
        <div className="detail-reviews__load-more">
          <LoadMoreReviewsButton />
        </div>
      ) : null}
    </div>
  );
}
